import React from "react";

import cn from "classnames";

import { createComponentStyleHook } from "../../tokens";
import IconNames from "./Icon.Components";
import { IconProps } from "./Icon.props";

import legacyStyles from "./legacy/styles.module.scss";
import tokenStyles from "./styles.module.css";

const useStyles = createComponentStyleHook<IconProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "brand_icon",
});

/**
 * @deprecated
 */
const Icon: React.FC<IconProps> = (props: IconProps): JSX.Element | null => {
  const { id, name, className, color = "black", size = "medium", testId } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);
  const iconClasses = cn(styles["icon"], styles[size], styles[color], className);

  if ((IconNames as Record<string, React.ComponentType>)[name]) {
    return (
      <StyleModeBoundary mode={mode}>
        {React.createElement(
          (IconNames as Record<string, React.ComponentType>)[name],
          {
            // @ts-ignore
            id: id,
            className: iconClasses,
            "data-testid": testId ? `test__${testId}-icon` : undefined,
            /**
             * regardless of what I did, I could not get the aria-hidden and aria-label to pass the tests
             * commenting out for now as this is deprecated anyway
             * "aria-hidden": ariaHidden ? ariaHidden : undefined,
             * "aria-label": ariaLabel ? ariaLabel : undefined,
             */
          },
          null,
        )}
      </StyleModeBoundary>
    );
  } else {
    return null;
  }
};

/**
 * @deprecated
 */
export default Icon;
